<template>
	<div>
		<loading v-if="!loaded" />
		<div class="md-layout" v-if="loaded">
			<div class="md-layout-item md-small-size-100 md-size-100">
				<h3>ព័ត៌មានអតិថិជន</h3>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-50">

				<md-table>
					<md-table-row>
						<md-table-cell style="width: 40%;">ឈ្មោះចូលប្រព័ន្ធ</md-table-cell>
						<md-table-cell style="width: 5px">:</md-table-cell>
						<md-table-cell>
							<span v-if="String(client.hash_id).length > 0"><b>{{client.username}}</b></span>
							<span v-else>N/A</span>
						</md-table-cell>
					</md-table-row>
					<md-table-row>
						<md-table-cell>ឈ្មោះអតិថិជន</md-table-cell>
						<md-table-cell>:</md-table-cell>
						<md-table-cell>
							<span v-if="String(client.name).length > 0"><b>{{client.name}}</b></span>
							<span v-else>N/A</span>
						</md-table-cell>
					</md-table-row>
					<md-table-row>
						<md-table-cell>លេខទូរស័ព្ទអតិថិជន</md-table-cell>
						<md-table-cell>:</md-table-cell>
						<md-table-cell>
							<span v-if="String(client.phone).length > 0"><b>{{client.phone}}</b></span>
							<span v-else>N/A</span>
						</md-table-cell>
					</md-table-row>
					<md-table-row>
						<md-table-cell>ទឹកប្រាក់</md-table-cell>
						<md-table-cell>:</md-table-cell>
						<md-table-cell>
							<span v-if="String(client.balance).length > 0"><b>{{config.moneylify(client.balance)}}</b></span>
							<span v-else>N/A</span>
						</md-table-cell>
					</md-table-row>
				</md-table>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-50">
				<!-- <h3>Client Detail</h3> -->
				<md-table>
					<md-table-row>
						<md-table-cell>ថ្ងៃចូលប្រព័ន្ធចុងក្រោយ</md-table-cell>
						<md-table-cell>:</md-table-cell>
						<md-table-cell>
							<span v-if="String(client.last_login).length > 0"><b>{{config.datelify(client.last_login)}}</b> ({{config.timelify(client.last_login)}})</span>
							<span v-else>N/A</span>
						</md-table-cell>
					</md-table-row>
					<md-table-row>
						<md-table-cell>ថ្ងៃបានបង្កើត</md-table-cell>
						<md-table-cell>:</md-table-cell>
						<md-table-cell>
							<span v-if="String(client.created_date).length > 0"><b>{{config.datelify(client.created_date)}}</b> ({{config.timelify(client.created_date)}})</span>
							<span v-else>N/A</span>
						</md-table-cell>
					</md-table-row>
					<md-table-row>
						<md-table-cell>ចំនួនចូលក្នុងប្រព័ន្ធ</md-table-cell>
						<md-table-cell>:</md-table-cell>
						<md-table-cell>
							<span v-if="String(client.total_login).length > 0"><b>{{client.total_login}} ដង</b></span>
							<span v-else>N/A</span>
						</md-table-cell>
					</md-table-row>
					<md-table-row>
						<md-table-cell>ស្ថានភាព</md-table-cell>
						<md-table-cell>:</md-table-cell>
						<md-table-cell>
							<span v-if="String(client.status).length > 0">
								<span class="green" v-if="client.status == 1">{{ config.getStatus(client.status) }}</span>
								<span class="error" v-if="client.status == 0">{{ config.getStatus(client.status) }}</span>
							</span>
							<span v-else>N/A</span>
						</md-table-cell>
					</md-table-row>
				</md-table>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-100">
				<h3>អ្នកដែលបានណែនាំ</h3>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-100">
				<md-table v-if="referralList.length > 0">
					<md-table-row>
						<md-table-head>ល.រ</md-table-head>
						<md-table-head>ឈ្មោះចូលប្រព័ន្ធ</md-table-head>
						<md-table-head>ព័ត៌មាន</md-table-head>
						<md-table-head>សមតុល្យទឹកប្រាក់</md-table-head>
						<md-table-head>ថ្ងៃចូលប្រព័ន្ធចុងក្រោយ</md-table-head>
						<md-table-head>ថ្ងៃបង្កើត</md-table-head>
						<md-table-head>ស្ថានភាព</md-table-head>
						<md-table-head>សកម្មភាព</md-table-head>
					</md-table-row>

					<md-table-row v-for="(client, index) in referralList">
						<md-table-cell>{{ index + 1 }}</md-table-cell>
						<md-table-cell>
							<img src="@/assets/img/default-member.png" style="width: 34px; margin-right:5px">
							<b>{{ client.username }}</b>
						</md-table-cell>
						<md-table-cell><b>{{ client.name }}</b><br>{{ client.phone }}</md-table-cell>
						<md-table-cell><b>{{ config.moneylify(client.balance) }}</b></md-table-cell>
						<md-table-cell><b>{{ config.datelify(client.last_login) }}</b><br>{{config.timelify(client.last_login)}}</md-table-cell>
						<md-table-cell><b>{{ config.datelify(client.created_date) }}</b><br>{{config.timelify(client.created_date)}}</md-table-cell>
						<md-table-cell>
							<span class="green" v-if="client.status == 1">{{ config.getStatus(client.status) }}</span>
							<span class="error" v-if="client.status == 0">{{ config.getStatus(client.status) }}</span>
						</md-table-cell>
						<md-table-cell>
							<router-link :to="'/clients/detail/' + client.hash">
								<md-button class="md-just-icon md-simple md-primary">
									<md-icon>visibility</md-icon>
									<md-tooltip md-direction="top">បង្ហាញបន្ថែម</md-tooltip>
								</md-button>
							</router-link>
							<!-- <router-link :to="'/clients/edit/' + client.hash">
								<md-button class="md-just-icon md-simple md-info">
									<md-icon>edit</md-icon>
									<md-tooltip md-direction="top">កែប្រព័ត៌មាន</md-tooltip>
								</md-button>
							</router-link> -->
						</md-table-cell>
					</md-table-row>
				</md-table>
				<h4 class="text-center" v-if="referralList.length == 0 && referralLoaded">មិនមាន</h4>
				<!-- <div class="places-buttons text-center" v-if="loadMore">
					<md-button class="md-primary" @click="getPackage(true)">បង្ហាញបន្ថែម</md-button>
				</div> -->
			</div>
		</div>
	</div>
	</div>

</template>

<script>
	import { Datetime } from 'vue-datetime';
	import StatsCard from '@/components/Cards/StatsCard'
	export default {
		components: { Datetime, StatsCard },
		created() {
			this.getClient();
			this.searchReferral();
		},

		data() {
			return {
				tabName: "first",
				loaded: false,
				referralLoaded: false,
				client: {
					hash_id: "",
					name: "",
					phone: "",
					note: "",
					created_date: ""
				},
				data: {
					total_deposit: 0,
					total_withdraw: 0,
					total_bet: 0,
					total_win: 0
				},
				loadMore: false,
				referralList: [],
				referralLoadMore: false,
			}
		},
		methods: {
			getClient() {
				this.$http.get(this.config.api + "/admin/user/get/" + this.$route.params.hash_id).then(data => {
					this.client = data.body.data
					this.loaded = true;
				})
				this.$http.get(this.config.api + "/admin/user/get_stat/" + this.$route.params.hash_id).then(data => {
					this.data = data.body.data
				})
			},
			searchReferral(more = false) {
				this.$http.post(this.config.api + "/admin/referral/get_referral_list", {
					hash_id: this.$route.params.hash_id,
					offset: more ? this.referralList.length : 0
				}).then(data => {
					this.referralLoaded = true;
					if (data.body.data.length == 100) this.referralLoadMore = true;
					else this.referralLoadMore = false;
					this.referralList = more ? this.referralList.concat(data.body.data) : data.body.data;
				})
			},
		}
	}
</script>
<style scoped>
	.product-thumbnail {
		width: 64px;
		height: 64px;
	}

	.grid-8 {
		text-align: center;
		max-width: 20%;
		min-width: 20%;
		flex: 0 0 20%;
	}

	.thumb-product {
		width: 50%;
	}
</style>



// WEBPACK FOOTER //
// src/pages/Referral/Detail.vue